import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { RevokeResponse, UpdateFactory, UpdateInfoModel, UpdateModel } from '../models';
import { UpdateRepository } from '../repository';
import { BaseService } from './base';

@Injectable({ providedIn: 'root' })
export class UpdatesService extends BaseService<UpdateModel> {
  private readonly apiService = inject(ApiService);

  constructor(protected override readonly repository: UpdateRepository) {
    super(repository);
  }

  public async updates(): Promise<UpdateModel[]> {
    try {
      const path: string = `${UpdateFactory.getPath()}`;
      const updates: UpdateModel[] = await this.apiService.get({ path });
      return updates;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async revokeAccess(accountId: string): Promise<RevokeResponse> {
    try {
      const path: string = `${UpdateFactory.getPath()}/${accountId}/revoke`;
      const result: RevokeResponse = await this.apiService.post<RevokeResponse>({ path });
      return result;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }

  public async getUpdateInfo(accountId: string): Promise<UpdateInfoModel> {
    try {
      const path: string = `${UpdateFactory.getPath()}/${accountId}/info`;
      const info: UpdateInfoModel = await this.apiService.get({ path });
      return info;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
